import { Injectable } from '@angular/core';
import { EventDataService } from '../api/event-data.service';

@Injectable({
  providedIn: 'root'
})

export class EventService {
  constructor(private eventdataservice: EventDataService) { }
  // UPLOAD IMAGE
  public uploadEventImageData(data) {
    return this.eventdataservice.uploadEventImageData(data);
  }

  // createArticleText
  public createEventText(data) {
    return this.eventdataservice.createEventText(data);
  }
  // saveInstitutionArticle
  public saveInstitutionEvents(data) {
    return this.eventdataservice.saveInstitutionEvents(data);
  }
  // getImagePresignedUrl
  public getImagePresignedUrl(data) {
    return this.eventdataservice.getImagePresignedUrl(data);
  }
  // getAllInstitutionEvents
  public getAllInstitutionEvents(data) {
    return this.eventdataservice.getAllInstitutionEvents(data);
  }
  // getAllArticle
  public getAllEvents(id, data) {
    return this.eventdataservice.getAllEvents(id, data);
  }
  // getAllArticle
  public getAllEvent(id, data) {
    return this.eventdataservice.getAllEvent(id, data);
  }
  // approveArticle
  public approveEvents(id) {
    return this.eventdataservice.approveEvents(id);
  }
  // getAllArticle
  public getAllEventsInstitution(data) {
    return this.eventdataservice.getAllEventsInstitution(data);
  }
  // getAllArticle
  public getInstitutionEventsById(data) {
    return this.eventdataservice.getInstitutionEventsById(data);
  }
  // reject Article
  public rejectEvent(id) {
    return this.eventdataservice.rejectEvent(id);
  }
  // //getInstitutionEventsById
  // public getInstitutionEventsById(data){
  //   return this.eventdataservice.getInstitutionEventsById(data);
  // }
  // Get All Article For Institution By Institution Id
  public getAllEventsForInstitutionByInstitutionId(id) {
    return this.eventdataservice.getAllEventsForInstitutionByInstitutionId(id);
  }
  // EditInstitutionArticleImageAfterSaved
  public editInstitutionEventImageAfterSaved(data) {
    return this.eventdataservice.editInstitutionEventImageAfterSaved(data);
  }

  // update Article text
  public update(eventId, data) {
    return this.eventdataservice.update(eventId, data);
  }
  // Delete Article
  public delete(eventId) {
    return this.eventdataservice.delete(eventId);
  }
  // Delete Article image
  public deleteInstitutionEventImageAfterSaved(data) {
    return this.eventdataservice.deleteInstitutionEventImageAfterSaved(data)
  }
  // Delete Article Before Save image
  public deleteInstitutionEventImagebeforeSaved(data) {
    return this.eventdataservice.deleteInstitutionEventImagebeforeSaved(data)
  }
  // getAllArticleImageByInstitutionId
  public getAllEventImageByInstitutionId(id) {
    return this.eventdataservice.getAllEventImageByInstitutionId(id)
  }


  //save Event
  public saveEvent(data) {
    return this.eventdataservice.saveEvent(data)
  }

  //save Event
  public saveArticle(data) {
    return this.eventdataservice.saveArticle(data)
  }

  //Update Event 
  public updateEvent(id, data) {
    return this.eventdataservice.updateEvent(id, data);
  }
  // get All Event Schedule By Id
  public getAllEventScheduleById(id) {
    return this.eventdataservice.getAllEventScheduleById(id);
  }

  //Get All EVent by  Instution Id
  public getAllEventScheduleByInstutionId(id, data) {
    return this.eventdataservice.getAllEventScheduleByInstutionId(id, data);
  }

  //Delete the Event Schedule
  public deleteEventSchedule(eventscheduleId) {
    return this.eventdataservice.deleteEventSchedule(eventscheduleId);
  }
  // getAllComments
  public saveComments(data) {
    return this.eventdataservice.saveComments(data)
  }
  // getAllComments
  public getAllComments(id) {
    return this.eventdataservice.getAllComments(id);
  }
  // saveReplyToComments
  public reply(id, data) {
    return this.eventdataservice.reply(id, data);
  }

  // Approve & Reject Event
  public approveRejectEvent(data) {
    return this.eventdataservice.approveRejectEvent(data);
  }
  // Get All Public Event
  public publicEvent(data) {
    return this.eventdataservice.publicEvent(data);
  }
}
